import type { QueryApi } from "../../api/query";

export function createUseRelatedProjects($api: QueryApi) {
  return function useRelatedProjects(params: { projectId: string; page?: number; size?: number }) {
    return $api.useQuery(
      "get",
      "/projects/{id}/related",
      {
        params: {
          path: { id: params.projectId },
          query: { page: params.page ?? 0, size: params.size ?? 10 },
        },
      },
      { enabled: !!params.projectId, staleTime: 5 * 60_000 },
    );
  };
}
